const ITEMS = [
    { t: "BTC/USDT", c: "+2.34%", up: true },
    { t: "ETH/USDT", c: "+1.82%", up: true },
    { t: "BNB/USDT", c: "+1.24%", up: true },
    { t: "SOL/USDT", c: "-0.42%", up: false },
    { t: "XRP/USDT", c: "+1.10%", up: true },
    { t: "SUB-SECOND EXECUTION", c: "", up: true },
    { t: "DEEP LIQUIDITY", c: "", up: true },
    { t: "INSTITUTIONAL SECURITY", c: "", up: true },
    { t: "GLOBAL COVERAGE", c: "", up: true },
];

/* Slow editorial metrics ribbon (demo figures, clearly illustrative) */
export default function Marquee() {
    const strip = (hidden) => (
        <div aria-hidden={hidden || undefined} className="flex shrink-0 items-center">
            {ITEMS.map((it, i) => (
                <span key={`${it.t}-${i}`} className="flex items-center">
                    <span className="px-8 font-mono text-[11px] uppercase tracking-[0.28em] text-slate-500">
                        {it.t}
                        {it.c && (
                            <span className={`ml-3 ${it.up ? "text-bull" : "text-bear"}`}>
                                {it.c}
                            </span>
                        )}
                    </span>
                    <span className="h-1 w-1 rotate-45 bg-roy/60" />
                </span>
            ))}
        </div>
    );

    return (
        <div className="hairline-t relative overflow-hidden border-b border-white/[0.06] bg-panel/40 py-4">
            <div className="flex w-max animate-marquee">
                {strip(false)}
                {strip(true)}
            </div>
            <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-void to-transparent" />
            <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-void to-transparent" />
        </div>
    );
}
